import styled from 'styled-components';
export const PreviewWrapper = styled.div `
  display: flex;
  gap: var(--space-400);
  margin-top: var(--space-400);
`;
export const PreviewContainer = styled.div `
  height: 400px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
`;
export const Preview = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-400);
  padding: var(--space-400);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-brand);
  width: 300px;
  max-height: 300px;
  overflow-y: auto;
`;
export const SettingsLabel = styled.div `
  position: absolute;
  top: 20px;
  left: var(--space-400);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-300);
  color: var(--text-secondary);
  margin-bottom: var(--space-200);
`;
export const IframeContainer = styled.div `
  width: 500px;
  max-height: 300px;
  overflow: none;
`;
export const ScaledIframe = styled.iframe `
  --scale-ratio: ${({ scaleRatio = 0.5 }) => scaleRatio};
  width: 1000px;
  height: 600px;
  transform-origin: top left;
  transform: scale(var(--scale-ratio, 1));
  border: none;
  overflow: none;
`;
export const MembershipToggle = styled.div `
  display: flex;
  gap: var(--space-400);
  margin-bottom: var(--space-400);
  align-items: center;
  padding: var(--space-400);
`;
export const MembershipLabel = styled.div `
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
  font-size: var(--font-size-300);
`;
export const MembershipButtons = styled.div `
  display: flex;
  gap: var(--space-200);
`;
export const MembershipButton = styled.button `
  padding: var(--space-200) var(--space-300);
  border: 1px solid ${({ $active }) => ($active ? 'var(--bg-brand)' : 'var(--border-primary)')};
  border-radius: var(--radius-brand);
  background-color: ${({ $active }) => ($active ? 'var(--bg-brand)' : 'var(--bg-secondary)')};
  color: ${({ $active }) => ($active ? 'var(--text-on-brand)' : 'var(--text-primary)')};
  font-size: var(--font-size-200);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${({ $active }) => $active ? 'var(--bg-brand-hover)' : 'var(--bg-tertiary)'};
    border-color: ${({ $active }) => $active ? 'var(--bg-brand-hover)' : 'var(--border-secondary)'};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px var(--bg-brand-secondary);
  }
`;
